export default __webpack_public_path__ + "static/media/parallax-bg41.6324f7e7.jpg";